import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PAYMENT_METHOD } from "./apiRoutes";

interface UseGetProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPaymentMethodDropdown = async (communityId: string) =>
  await axiosAuth.get(`${PAYMENT_METHOD}/community/${communityId}/dropdown`);

const useGetPaymentMethodDropdown = ({
  communityId,
  queryParams,
}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["payment-method-dropdown", communityId],
    queryFn: () => getPaymentMethodDropdown(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPaymentMethodDropdown;
